import { CRISIS_RESOURCES } from './crisisResources';

type SelfHarmCategory = 'PROMOTION' | 'AT_RISK' | 'NONE';

export const SafetyPanel = ({ category }: { category?: SelfHarmCategory | null }) => {
  if (!category || category === 'NONE') return null;

  const isBlock = category === 'PROMOTION';
  return (
    <section className={`SAFETY__PANEL ${isBlock ? 'SAFETY__PANEL--block' : 'SAFETY__PANEL--atrisk'}`} role="note">
      <h4 className="SAFETY__PANEL__TITLE">{isBlock ? 'Cannot be published' : 'Support is available'}</h4>
      <p className="SAFETY__PANEL__BODY">
        {isBlock
          ? "This story appears to promote self-harm and can’t be published. Please revise it before publishing."
          : "If you’re going through a hard time, you don’t have to face it alone. Help is available 24/7."}
      </p>
      <ul className="SAFETY__PANEL__RESOURCES">
        {CRISIS_RESOURCES.map((r) => (
          <li key={r.label}>
            {r.href
              ? <a href={r.href}>{r.label}: {r.contact}</a>
              : <span>{r.label}: {r.contact}</span>}
          </li>
        ))}
      </ul>
    </section>
  );
};
